import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const PermissionValidator = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    description: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export const PermissionArrayValidator = t.array(
  PermissionValidator
);

export type Permission = t.TypeOf<typeof PermissionValidator>;
export type PermissionArray = t.TypeOf<typeof PermissionArrayValidator>;

@Exclude()
export class PermissionEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  description?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  readonly entityType = 'PERMISSION';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for PermissionEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: Permission): PermissionEntity {
    return plainToInstance(PermissionEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<Permission> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(PermissionValidator, object);
  }

  asTypeValue(): Permission {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(PermissionValidator, object);
  }
}
